import { render, staticRenderFns } from "./textNote.vue?vue&type=template&id=0b3e931a&scoped=true&"
import script from "./textNote.vue?vue&type=script&lang=js&"
export * from "./textNote.vue?vue&type=script&lang=js&"
import style0 from "./textNote.vue?vue&type=style&index=0&id=0b3e931a&scoped=true&lang=css&"
import style1 from "./textNote.vue?vue&type=style&index=1&id=0b3e931a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3e931a",
  null
  
)

export default component.exports